import React from 'react';

import { RADIUS_FIELDS } from '../../common/fields';
import TextInput from '../Controls/TextInput/TextInput';
import CopyButton from '../Controls/CopyButton/CopyButton';

import styles from './RadiusClient.module.css';
import SwitchField from '../Controls/SwitchField/SwitchField';
import { Tooltip } from '@material-ui/core';
import { SUBCATEGORIES } from '../../common/categories';

const { RADIUS_CLIENTS } = SUBCATEGORIES;

const { IP_ADDRESS, SECRET, ENABLE_RADIUS_OTP, DISABLE_FIRST_FACTOR } = RADIUS_FIELDS;

const RadiusClient = ({ radius, changedFunc }) => {
    return (
        <div className={styles.radiusClient}>
            <div className="flex flex-col">
                <TextInput
                    field={radius[IP_ADDRESS.ID]}
                    placeholder="192.168.2.0/22"
                    color="grey"
                    changed={changedFunc}
                    featureLockId={RADIUS_CLIENTS.ID}
                    featureLockIsTabId={true}
                />
            </div>
            <TextInput
                type="password"
                field={radius[SECRET.ID]}
                color="grey"
                changed={changedFunc}
                featureLockId={RADIUS_CLIENTS.ID}
                featureLockIsTabId={true}>
                <CopyButton value={radius[SECRET.ID].value} />
            </TextInput>
            <div className={styles.switchesContainer}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SwitchField
                        field={radius[ENABLE_RADIUS_OTP.ID]}
                        changed={changedFunc}
                        featureLockId={RADIUS_CLIENTS.ID}
                        featureLockIsTabId={true}
                    />
                    <Tooltip
                        enterDelay={100}
                        title={
                            'RADIUS OTP allows the client to send the passwords and OTP code in the same line while using the PAP authentication protocol.'
                        }
                        placement={'bottom'}
                        classes={{ tooltip: 'generic-tooltip' }}>
                        <div className="moreInfoIcon"></div>
                    </Tooltip>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SwitchField
                        field={radius[DISABLE_FIRST_FACTOR.ID]}
                        changed={changedFunc}
                        featureLockId={RADIUS_CLIENTS.ID}
                        featureLockIsTabId={true}
                    />
                    <Tooltip
                        enterDelay={100}
                        title={
                            'With this toggle enabled, Silverfort will not authenticate the request with the AD but only vs. the policy.'
                        }
                        placement={'bottom'}
                        classes={{ tooltip: 'generic-tooltip' }}>
                        <div className="moreInfoIcon"></div>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default React.memo(RadiusClient);
